
import { KEYS_LOCALSTORAGE } from 'constants/general';

export const LOCAL_ORG_NAME = () => localStorage.getItem(KEYS_LOCALSTORAGE.ORGANIZATION_NAME) || '';
export const LOCAL_ORG_ID = () => localStorage.getItem(KEYS_LOCALSTORAGE.ORGANIZATION_ID) || '0';
export const LOCAL_CENTER_NAME = () => localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVE_CENTER_NAME);
export const LOCAL_CENTER_ID = () => localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVE_CENTER_ID) || '0';
export const LOCAL_CENTER_EXTERNAL_ID = () => localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVE_CENTER_EXTERNAL_ID) || '0';
export const LOCAL_ACTIVE_CENTER_TOKEN = () => localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVE_CENTER_TOKEN) || '';
export const LOCAL_ACCOUNT_TOKEN = () => localStorage.getItem(KEYS_LOCALSTORAGE.ACCOUNT_TOKEN);
export const LOCAL_AUTH_TOKEN = () => localStorage.getItem(KEYS_LOCALSTORAGE.AUTH_TOKEN) || '';
export const LOCAL_SELECTED_GROUP_ID = () => localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVE_GROUP_ID);
export const LOCAL_SELECTED_GROUP_NAME = () => localStorage.getItem(KEYS_LOCALSTORAGE.CLASSROOM_NAME);
export const LOCAL_USER_ID = () => localStorage.getItem(KEYS_LOCALSTORAGE.USER_ID) || '';
export const LOCAL_USER_EMAIL = () => localStorage.getItem(KEYS_LOCALSTORAGE.USER_EMAIL) || '';
export const LOCAL_USER_TYPE = () => localStorage.getItem(KEYS_LOCALSTORAGE.USER_TYPE) || '';
export const LOCAL_VIEW_HOW_IT_WORKS = () => localStorage.getItem(KEYS_LOCALSTORAGE.VIEW_HOW_IT_WORKS);
export const SESSION_ORG_TOKEN = () => sessionStorage.getItem('ORG_TOKEN') || '';
